'use strict';
import {EwSiteApp} from '../../app/ewsiteapp.js';

EwSiteApp.controller('SuggestSearchCtrl', ['$scope', '$log', 'ajaxSearch', '$timeout', '$sce', '$filter', function ($scope, $log, ajaxSearch, $timeout, $sce, $filter) {
    $scope.searchUrl = '';
    $scope.sdquery = '';
    $scope.searchresults = [];
    $scope.total = 0;
    $scope.search_url = '';
    $scope.inputTouched = false;
    $scope.templates = {
        title_description: 'search/title_description.html',
        img_title: 'search/img_title.html',
        img_title_description: 'search/img_title_description.html',
        module_gallery: 'search/module_gallery.html',
        module_youtubegallery: 'search/module_youtubegallery.html',
    };
    $scope.str_len = 100;

    // Move the highlightFilter function outside of the controller
    function highlightFilter(text, search) {
        if (!search) {
            return $sce.trustAsHtml(text);
        }
        return $sce.trustAsHtml(text.replace(new RegExp(search, 'gi'), '<span class="highlight">$&</span>'));
    }

    // Expose the function to the $scope
    $scope.highlightFilter = highlightFilter;

    $scope.find = function () {
        if ($scope.searchUrl !== '') {
            $timeout(function () {
                $scope.inputTouched = true;
            }, 500);
            ajaxSearch.search($scope.searchUrl, { sdquery: $scope.sdquery }).then(function (results) {
                if ($scope.sdquery === '') {
                    $scope.clear();
                } else {
                    $scope.displaySuggestions(results);
                    $scope.total = results.total;
                    $scope.search_url = results.search_url;
                }
            }, function (response) {
                $log.error(response);
            });
        }
    };

    $scope.displaySuggestions = function (results) {
        $scope.searchresults = results.data;
    };

    $scope.clear = function () {
        $scope.sdquery = '';
        $scope.total = 0;
        $scope.displaySuggestions([]);
    };

    $scope.getDataTemplate = function (data) {
        if (data.module === 'gallery' || data.module === 'photoalbums') {
            data.display_options.template.id = 'module_gallery';
        }
        if (data.module === 'youtubegallery') {
            data.display_options.template.id = 'module_youtubegallery';
        }
        if (typeof (data.display_options.template.id) !== 'undefined' && typeof ($scope.templates[data.display_options.template.id]) !== 'undefined') {
            return $scope.templates[data.display_options.template.id];
        }
        return $scope.templates.title_description;
    };

    $scope.changeLocationHash = function (data, name, varname) {
        var hash = '!' + name + data.display_options.vars[varname];
        location.hash = hash;
    };

    // Custom date formatting filter for Lithuanian date format
    $scope.formatCustomDate = function (timestamp) {
        if (!timestamp) return '';

        // Convert timestamp to Date object
        const date = new Date(timestamp * 1000);

        // Extract year, day, and month
        const year = $filter('date')(date, 'yyyy');
        const day = $filter('date')(date, 'dd');

        // Define month names in Lithuanian
        const monthNames = [
            'sausio', 'vasario', 'kovo', 'balandžio', 'gegužės', 'birželio',
            'liepos', 'rugpjūčio', 'rugsėjo', 'spalio', 'lapkričio', 'gruodžio'
        ];
        const month = monthNames[date.getMonth()];  // Get month name

        // Return formatted string in Lithuanian style
        return `${year} m. ${month} ${day} d.`;
    };
}]).directive('suggestSearchContainer', function () {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            scope.searchUrl = '';
            if (attr.searchUrl !== '') {
                scope.searchUrl = attr.searchUrl;
            }
        }
    };
});